<template>
    <div class="container">
        <h1 class="title" v-if="windowWidth>=400">Empresas que ya han contratado talento<br> dev con Ademass</h1>
        <h1 class="title-2" v-else>Empresas que ya han contratado talento dev <br>con Ademass</h1>
        <div class="tbody">
            <div class="grey"  v-show="windowWidth>=1000" >
                <img src="/external/francisco.png" class="img-fra" alt="Francisco">
            </div>
            <div class="green">
                <p class="text">"Tras usar los servicios de selección de personal de Ademass no puedo más que mostrar mi admiración por lo bien engranado que está todo y de cómo en pocos días, mediante un proceso totalmente automatizado, han encontrado perfiles adecuados a mis necesidades."</p>
                <div class="fr">
                <p class="text-name">Francisco Oliva   </p>
                <img src="/external/Cripto2.png"  alt="Francisco" width="160">
            </div>
               
            </div>
        </div>
    </div>
    </template>
    
    <script setup>
    import useWindowWidth from '@/composables/useWindowWidth';

const { windowWidth } = useWindowWidth();

    </script>
    
    <style scoped>
    .img-fra{
        width: 246px;
         height: 100%;
        border-radius: 15px 0 0 15px;
        overflow: hidden;
    }
    .container{
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-bottom: 100px;
        overflow: hidden;
       
    }
    .title {
      color: rgba(39, 52, 68, 1);
      font-size: 60px;
      font-style: Black;
      text-align: center;
      font-family: Darker Grotesque;
      font-weight: 900;
      line-height: 94.9999988079071%;
      margin-bottom: 30px;
    }
    .green{
        
        background-color: #c4cf2c;
        border-radius: 0 15px 15px 0;
       justify-content: center;
        width: 580px;
        height: 310px;
        display: flex;
        padding-left: 100px;
        flex-direction: column;
        padding-top: 15px;
    }
    .grey{
        background-color: #d9d9d9;
        border-radius: 15px 0 0 15px;
        width: 246px;
       

    
    }
    .tbody{
       display: flex;
       margin-top: 0;
    }
    .text {
    margin-right: 20px;
    margin-top: 15px;
    height: 100%;
    margin-left: 30px;
    color:white;
    max-width: 400px;
    height: auto;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;

}
.text-name {
    
    margin-left: 30px;
    color:white;
    max-width: 400px;
    height: auto;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}
.fr{
    display: flex;
    align-items: center;
}
    @media screen and (max-width: 600px) {
        .title-2{
            padding-right: 15px;
            width: 95%;
            color: rgba(39, 52, 68, 1);
          font-size: 50px;
          font-style: Black;
          text-align: center;
          font-family: Darker Grotesque;
          font-weight: 900;
        }
       
        .container{
            width: 100%;
            margin-bottom: 30px;
        }
        .grey{
           visibility: hidden;
           height: 80px;

        }
        .title{
            margin-bottom: 0;
        }
        .tbody{
            flex-wrap: wrap;
        width: 100%;
        align-items: center;
        justify-content: center;
        }
        .green{
            margin-top: 25px;
            height: 450px;
            padding-left: 0;
            width: 90%;
            border-radius: 15px;
           
        }
   }
  
    </style>